
'use strict';

import intlTelInput from 'intl-tel-input';
const utils = require('intl-tel-input/build/js/utils');

function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger fade show" role="alert">' + message + '</div>';
    $('.service-error-alert').append(errorHtml);
    $(window).scrollTop($('div.service-error-alert').position().top - 300);

    // Auto dismiss
    setTimeout(function() {
        $('.alert.alert-danger').alert('close');
    }, 3000);
}

function enableInvalidFeedback(dwfrmNames) {
    var lastError = null;

    var $feedback_divs = $('.invalid-feedback:visible');
    if ($feedback_divs.length) {
        for(var i=0; i<$feedback_divs.length; i++) {
            $($feedback_divs[i]).addClass('d-none');
        }
    }

    var $allFormInputs = $("input[class='form-control']");
    if ($allFormInputs.length) {
        for(var i=0; i<$allFormInputs.length; i++) {
            $($allFormInputs[i]).removeClass('is-invalid');
        }
    }

    $.each(dwfrmNames, function(dwfrmName, value ) {
        var $relatedInput = $('input[name=' + dwfrmName + ']');
        $relatedInput.addClass('is-invalid');
        var $inputParent = $relatedInput.parent();
        var $invalidFeedback = $inputParent.find('.invalid-feedback');
        $invalidFeedback.text(value);
        $invalidFeedback.addClass('d-block');
        lastError = $invalidFeedback;
    });

    if (lastError) {
        $(window).scrollTop($(lastError).position().top);
        var $target = $(lastError).parent().find('input, select')[0];
        $target.focus();
    }
}

function validatePrivacyFields() {
    var radioGroups = [
        'dwfrm_profile_customer_marketing',
        'dwfrm_profile_customer_newsletter',
        'dwfrm_profile_customer_profilazione'
    ];
    radioGroups.forEach(function(name) {
        var $error = $('#form-privacy-' + name.split('_').pop() + '-error');
        if ($('input[name="' + name + '"]:checked').length === 0) {
            $error.text('Seleziona una di queste opzioni.').show();
        } else {
            $error.text('').hide();
        }
    });
}

function validateCountryField() {
    var $country = $('input[name="dwfrm_profile_customer_country"]');
    if (!$country.length) {
        return;
    }
    var $error = $('#form-privacy-check-error');
    if ($country.filter(':checked').length === 0) {
        $error.text('Seleziona una di queste opzioni.').show();
    } else {
        $error.text('').hide();
    }
}


function validateNameFields() {
    var firstName = $('#registration-form-fname').val();
    var lastName = $('#registration-form-lname').val();
    var nameRegex = /^[a-zA-Zàèìòù' .]{0,50}$/;

    if (!nameRegex.test(firstName)) {
        $('.error_message_name_invalid').show();
    } else if (firstName === '') {
        $('#form-fname-error').show();
    } else {
        $('.error_message_name_invalid').hide();
        $('#form-fname-error').hide();
    }

    if (!nameRegex.test(lastName))
        $('.error_message_surname_invalid').show();
    else if (lastName === '') {
        $('#form-lname-error').show();
    } else {
        $('.error_message_surname_invalid').hide();
        $('#form-lname-error').hide();
    }

    if (firstName && lastName && firstName.toLowerCase().trim() === lastName.toLowerCase().trim()) {
        $('.error_message_same_name').show();
        $('#form-fname-error').hide();
        $('#form-lname-error').hide();
    } else {
        $('.error_message_same_name').hide();
    }
}

function validateBirthdateField() {
    var birthdateInput = $('#registration-form-bdate');
    var birthdate = birthdateInput.val();

    if (birthdate !== undefined && birthdate !== 'undefined') {
        var today = new Date();
        var minAge = 18;
        var maxAge = 100;
        var maxDate = new Date(today.getFullYear() - minAge, today.getMonth(), today.getDate());
        var minDate = new Date(today.getFullYear() - maxAge, today.getMonth(), today.getDate());
        var selectedDate = new Date(birthdate);

        if (birthdate === '') {
            $('#error_message_required').show();
            $('#error_message_maxDate').hide();
            $('#error_message_invalid').hide();
        } else if (selectedDate > today) {
            $('#error_message_invalid').show();
            $('#error_message_maxDate').hide();
            $('#error_message_required').hide();
            birthdateInput.val('');
        } else if (selectedDate > maxDate) {
            $('#error_message_maxDate').show();
            $('#error_message_required').hide();
            $('#error_message_invalid').hide();
            birthdateInput.val('');
        } else if (selectedDate < minDate) {
            $('#error_message_invalid').show();
            $('#error_message_maxDate').hide();
            $('#error_message_required').hide();
            birthdateInput.val('');
        } else {
            $('#error_message_maxDate').hide();
            $('#error_message_required').hide();
            $('#error_message_invalid').hide();
        }
    }
}

$(document).ready(function() {
    var $btnPrivacyFalse = $('#registrationPrivacy_false');
    var $btnPrivacyTrue = $('#registrationPrivacy_true');
    $('#error_message_maxDate').hide();
    $('#error_message_required').hide();

    const countryInput = $('#country-true, #country-false');
    if (countryInput && countryInput.length > 0) {
        countryInput.each(function() {
            $(this).click(function() {
                if ($(this).is(':checked')) {
                    $(this).prop('checked', true);
                    $(this).siblings().prop('checked', false);

                    const fiscalCodeInput = $('#registration-form-fiscalcode');
                    if (fiscalCodeInput.length > 0) {
                        if ($(this).val() === 'false') {
                           fiscalCodeInput.prop('disabled', true);
                           fiscalCodeInput.val('');
                        } else {
                           fiscalCodeInput.prop('disabled', false);
                        }
                    }
                    
                }
            });
        });
    }
    
    const phoneInputs = document.querySelectorAll("input[type='tel']");
    const allowedPattern = /^\+?[0-9\s\-().]*$/;
    if (phoneInputs && phoneInputs.length > 0) {
        phoneInputs.forEach(function(phoneInput) {
            phoneInput.addEventListener("input", function () {
                const value = this.value;
                if (!allowedPattern.test(value)) {
                    this.value = value.replace(/[^0-9\s\-().+]/g, "");
                    
                    const plusAtStart = this.value.startsWith("+");
                    const rest = this.value.replace(/\+/g, "");
                    this.value = plusAtStart ? "+" + rest : rest;
                }
            });
        });
    }
    
    
    if ($btnPrivacyFalse != null) {
        $btnPrivacyFalse.prop('checked', false);
        $btnPrivacyFalse.prop('checked', true);

        $btnPrivacyTrue.click(function(e) {
            $btnPrivacyFalse.prop('checked', false);
        });

        $btnPrivacyFalse.click(function(e) {
            $btnPrivacyTrue.prop('checked', false);
        });
    }

    var $a_resetPassword = $('#password-reset');
    if ($a_resetPassword != null) {
        $a_resetPassword.click(function() {
            var $radioBtnB2C = $('.user-type.user-type-private');
            var $fieldResetPasswordAgency = $('#reset-password-agency');
            var $targetDiv = $fieldResetPasswordAgency.parent();
            if ($radioBtnB2C.hasClass('active')) {
                $targetDiv.css('display', 'none');
                $fieldResetPasswordAgency.removeAttr('name');
                if ($targetDiv.hasAttr('required')) {
                    $targetDiv.removeAttr('required');
                }
            } else {
                if ($targetDiv.css('display') == 'none') {
                    $targetDiv.removeAttr('style');
                }

                if (!$targetDiv.hasAttr('required')) {
                    $targetDiv.attr('required');
                }

                if (!$fieldResetPasswordAgency.hasAttr('name')) {
                    $fieldResetPasswordAgency.attr('name', 'agency');
                }
            }
        });
    }

    /*
    intl-tel-input plugin initialization
    Used in following input text IDs:
        - #registration-form-telefono
        - #registration-form-contatto_azienda_telefono
        - #registration-form-contatto_azienda_cellulare
        - #registration-form-contatto_azienda_fax
    */

    var phoneInput_azienda_telefono = document.querySelector("#registration-form-contatto_azienda_telefono");
    var phoneInput_B2C_mobile = document.querySelector("#registration-form-mobilePhone");

    if (phoneInput_azienda_telefono == undefined && phoneInput_B2C_mobile == undefined) {
        // Not landed on B2B/B2C reg form
        return;
    }

    const initializationParams = {
        initialCountry: "it",
        separateDialCode: true,
        utilsScript: utils,
    };

    if (phoneInput_azienda_telefono != undefined) {
        var phoneInput_telefono = document.querySelector("#registration-form-telefono");
        var phoneInput_azienda_cellulare = document.querySelector("#registration-form-contatto_azienda_cellulare");
        var phoneInput_azienda_fax = document.querySelector("#registration-form-contatto_azienda_fax");
        const intl_input_telefono = intlTelInput(phoneInput_telefono, initializationParams);
        const intl_input_azienda_telefono = intlTelInput(phoneInput_azienda_telefono,initializationParams);
        const intl_input_azienda_cellulare = intlTelInput(phoneInput_azienda_cellulare, initializationParams);
        const intl_input_azienda_fax = intlTelInput(phoneInput_azienda_fax, initializationParams);
        if ($('#b2b-registration-form').length > 0) {
            // on form submit
            $('#b2b-registration-form').submit(function(e){
                e.preventDefault();
                e.stopImmediatePropagation();

                // format phone inputs with prefix
                var iti_telefono = intlTelInputGlobals.getInstance(phoneInput_telefono);
                $('#registration-form-telefono').val(iti_telefono.getNumber());

                var iti_telefono_azienda = intlTelInputGlobals.getInstance(phoneInput_azienda_telefono);
                $('#registration-form-contatto_azienda_telefono').val(iti_telefono_azienda.getNumber());

                var iti_cellulare_azienda = intlTelInputGlobals.getInstance(phoneInput_azienda_cellulare);
                $('#registration-form-contatto_azienda_cellulare').val(iti_cellulare_azienda.getNumber());

                var iti_fax_azienda = intlTelInputGlobals.getInstance(phoneInput_azienda_fax);
                $('#registration-form-contatto_azienda_fax').val(iti_fax_azienda.getNumber());

                var captcha = $('#g-recaptcha-init');
                if(captcha.length === 1 || captcha.length > 1){
                    var captchaResponse = grecaptcha.getResponse();
                    if (captchaResponse.length === 0) {            
                        $('.invalid-captcha').show();
                        return;           
                    } else {            
                        $('.invalid-captcha').hide();                
                    }
                }

                // Form submit
                $.ajax({
                    url: $('#b2b-registration-form').attr('action'),
                    type: $('#b2b-registration-form').attr('method'),
                    dataType: 'json',
                    data : $('#b2b-registration-form').serialize(),
                    success: function(response){
                        if (response && response.success) {
                            $('body').trigger('register:success', response);
                            if (response.redirectUrl) window.location.href = response.redirectUrl;
                        }
                    },
                    error: function(e) {
                        $('.modal-body').spinner().stop();
                        var rsp = JSON.parse(e.responseText);
                        createErrorNotification(typeof rsp.error !== 'undefined' ? rsp.error : rsp.errorMessage);
                    }
                });

                return false;
            });
        }
    }

    if (phoneInput_B2C_mobile != undefined) {
        if (phoneInput_B2C_mobile) {
            const intl_input_b2c_mobile = intlTelInput(phoneInput_B2C_mobile, initializationParams);
        }

         if ($('#b2c-registration-form').length > 0) {
             $('#b2c-registration-form').submit(function(e) {
                 e.preventDefault();
                 e.stopImmediatePropagation();

                 if (phoneInput_B2C_mobile) {
                     const iti_mobilePhone = intlTelInputGlobals.getInstance(phoneInput_B2C_mobile);
                     $('#registration-form-mobilePhone').val(iti_mobilePhone.getNumber());
                 }
                 if ($('#country-true').is(':checked') || $('#country-false').is(':checked')) {
                    $('#form-privacy-check-error').remove(); 
                    $('#country-true, #country-false').removeClass('is-invalid');                   
                }
            
                if ($('#registration-form-mobilePhone').val().trim() !== '') {
                    $('#form-mobilePhone-error').remove();
                }
                
                if($('.js-privacy-error:visible').length > 0){
                    $('.modal-body').spinner().stop();
                    return;
                }
                 // Form submit
                 $.ajax({
                     url: $('#b2c-registration-form').attr('action'),
                     type: $('#b2c-registration-form').attr('method'),
                     dataType: 'json',
                     data : $('#b2c-registration-form').serialize(),
                     success: function(response){
                         $('.modal-body').spinner().stop();

                         if (response && response.success) {
                             $('body').trigger('register:success', response);
                             if (response.redirectUrl) window.location.href = response.redirectUrl;
                         }

                         if (response && typeof response.fields !== 'undefined') {
                             $('form.registration').trigger('register:error', response);
                             enableInvalidFeedback(response.fields);
                         }
                     },
                     error: function(response) {
                         $('.modal-body').spinner().stop();
                         if (response && typeof response.responseJSON.fields !== 'undefined') {
                             $('form.registration').trigger('register:error', response.responseJSON);
                             enableInvalidFeedback(response.responseJSON.fields);
                         } else {
                             var rsp = JSON.parse(response.responseText);
                             createErrorNotification(typeof rsp.error !== 'undefined' ? rsp.error : rsp.errorMessage);
                         }
                     }
                 });

                 return false;
             });
         }
    }


    $('#registration-form-fname, #registration-form-lname').blur(validateNameFields);
    $('#registration-form-bdate').blur(validateBirthdateField);

    // on submit-button click()
    $('#submitRegistration').click(function(e){
        e.preventDefault();
        e.stopImmediatePropagation();

        validateNameFields();
        validateBirthdateField();
        validatePrivacyFields();
        validateCountryField();

        // Shows appropriate invalid-feedback divs for phone input fields wrapped with intl-tel-input plugin
        if (phoneInput_azienda_telefono != undefined) {
            intlTelInputGlobals.getInstance(phoneInput_telefono).isValidNumber() ?  $('#form-telefono-error').hide() :  $('#form-telefono-error').show();
            intlTelInputGlobals.getInstance(phoneInput_azienda_telefono).isValidNumber() ?  $('#form-contatto_azienda_telefono-error').hide() :  $('#form-contatto_azienda_telefono-error').show();
            intlTelInputGlobals.getInstance(phoneInput_azienda_cellulare).isValidNumber() ?  $('#form-contatto_azienda_cellulare-error').hide() :  $('#form-contatto_azienda_cellulare-error').show();
            intlTelInputGlobals.getInstance(phoneInput_azienda_fax).isValidNumber() ?  $('#form-contatto_azienda_fax-error').hide() :  $('#form-contatto_azienda_fax-error').show();
        }

        if (phoneInput_B2C_mobile != undefined) {
            $('#form-mobilePhone-error').show();
        }

        // If there are invalid-feedback divs, scroll to the first, focus on its related input/select component
        var $feedback_divs = $('.invalid-feedback:visible');
        if ($feedback_divs.length > 0) {
            $(window).scrollTop($($feedback_divs[0]).position().top);
            var $target = $($feedback_divs[0]).parent().find('input, select')[0];
            $target.focus();
        }

        $(document).find('#b2b-registration-form').length > 0 ? $('#b2b-registration-form').submit() : $('#b2c-registration-form').submit();
    });
});

$(document).ready(function() {
    var birthdateInput = $('#registration-form-bdate');
    var today = new Date();
    var minAge = 18;
    var maxAge = 100;
    var maxDate = new Date(today.getFullYear() - minAge, today.getMonth(), today.getDate());
    var minDate = new Date(today.getFullYear() - maxAge, today.getMonth(), today.getDate());
    var maxDateFormatted = maxDate.toISOString().split('T')[0];
    var minDateFormatted = minDate.toISOString().split('T')[0];

    birthdateInput.attr('max', maxDateFormatted);
    birthdateInput.attr('min', minDateFormatted);
});

window.onload = function() {
    $.fn.hasAttr = function(name) {
        return this.attr(name) !== undefined;
    };
}
